module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAOCAYAAAFlUW0AAAAABGdBTUEAALGPC/xhBQAAAHFJREFUGBmVj9ENwCAIRO06frdTuEHncdnqEPQkSEFrmpoo3vEEDGGxiGj3KTgx4Ehs41I0D1G3rgS5mIUYygBreKc1wsxWPITDnWg8jIR96Ftjcut5MIeKkDIV0Q/8P2EGKNNkY+9l+S9Qv/UCRnjnDcF0gimEA8G/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/views/left-arrow.png
// module id = 398
// module chunks = 0